import { render } from "./NavBarBrand.vue?vue&type=template&id=6ca79ebc&scoped=true&ts=true&lang=html"
import script from "./NavBarBrand.vue?vue&type=script&lang=ts"
export * from "./NavBarBrand.vue?vue&type=script&lang=ts"

import "./NavBarBrand.vue?vue&type=style&index=0&id=6ca79ebc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca79ebc"]])

export default __exports__